import React from "react";

const svgStyles = {
  cursor: "pointer",
};

const TrashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12}
    fill="none"
    style={svgStyles}
    {...props}
  >
    <path
      style={svgStyles}
      fill="#3E4957"
      d="M5.375.75h2.25c.207 0 .375.168.375.375v.75H5v-.75c0-.207.168-.375.375-.375ZM8.75 1.875v-.75C8.75.504 8.246 0 7.625 0h-2.25C4.754 0 4.25.504 4.25 1.125v.75H1.625a.375.375 0 1 0 0 .75h.404l.64 7.995A1.5 1.5 0 0 0 4.163 12h4.672a1.5 1.5 0 0 0 1.496-1.38l.64-7.995h.403a.375.375 0 0 0 0-.75h-.747a.32.32 0 0 0-.007 0H8.75Zm1.469.75-.635 7.935a.75.75 0 0 1-.748.69H4.164a.75.75 0 0 1-.748-.69l-.635-7.935h7.438Zm-5.616.75a.375.375 0 0 1 .396.353l.375 6.375a.375.375 0 0 1-.748.044L4.25 3.772a.375.375 0 0 1 .352-.396Zm3.794 0c.207.013.365.19.352.397l-.375 6.375a.375.375 0 0 1-.748-.044L8 3.728a.375.375 0 0 1 .396-.352Zm-1.897 0c.207 0 .375.168.375.375v6.375a.375.375 0 0 1-.75 0V3.75c0-.207.168-.375.375-.375Z"
    />
  </svg>
);
export default TrashIcon;
